import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-title',
  templateUrl: './pagetitle.component.html',
  styleUrls: ['./pagetitle.component.scss'],
  // The `title` input is also a native HTML attribute name — without this,
  // Angular leaves the static `title="..."` attribute sitting on the host
  // element in the rendered DOM (it isn't stripped just because it's also
  // consumed as an @Input()), which makes the browser show it as a native
  // tooltip over the whole host element's box, not just the visible text.
  host: { '[attr.title]': 'null' }
})
export class PagetitleComponent implements OnInit {

  @Input() breadcrumbItems: any;
  @Input() title: string;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  route(href){
    this.router.navigate([href]);
  }

}
